// extracted by mini-css-extract-plugin
export default {"dropButton":"ChangeLanguage_dropButton__d3y--"};